import { useMutation, useQueryClient } from '@tanstack/react-query';
import { surveysQueryKeys } from '../Constants/queryKeys';
import { SurveySlugHeldByDeletedError } from '../Services/Surveys.errors';
import { createSurvey } from '../Services/Surveys.service';
import type { SurveyCreatePayload } from '../Types/Surveys.types';
import { useActionToast } from '@/Hooks/useActionToast';

export const useCreateSurvey = () => {
  const queryClient = useQueryClient();
  const toast = useActionToast();

  return useMutation({
    mutationFn: (payload: SurveyCreatePayload) => createSurvey(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: surveysQueryKeys.lists() });
    },
    onError: (error: Error) => {
      /*
        The slug being held by a DELETED survey is not a failure to report and forget: it has one
        useful answer, which is to restore that survey. The caller opens the dialog that offers it,
        so this one error is swallowed here — the same arrangement `useApproveSurvey` has for the
        missing translations.
      */
      if (error instanceof SurveySlugHeldByDeletedError) return;

      toast.failure('Não foi possível criar a pesquisa', error);
    },
  });
};
